import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21d1a080"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mb-5" }
const _hoisted_2 = {
  key: 0,
  class: "notification is-warning mb-5"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Данный лид привязан к другому агенту. Вы можете назначить лида этому агенту, либо отказаться от дальнейших шагов.")
const _hoisted_4 = { class: "mt-2" }
const _hoisted_5 = {
  key: 1,
  class: "notification is-success mb-5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showReassign)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              class: _normalizeClass(["button is-primary", { 'is-loading': _ctx.isLoading }]),
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.changeOwner && _ctx.changeOwner(...args)))
            }, "Закрепить за текущим агентом", 2)
          ])
        ]))
      : (_ctx.showSuccessMessage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Лид поставлен в очередь на обновление. В течение нескольких минут данные обновятся и вы сможете добавить платёж"))
        : _createCommentVNode("", true)
  ]))
}